<div class="main" *ngIf="!isLoading">
  <div class="main-content">
    <div class="p-fluid p-formgrid p-grid search-screen">
      <div class="p-col-12 search-screen-wrapper">
        <div class="p-fluid p-formgrid p-grid search-screen-col grid">
          <div class="p-col-3 p-lg-3 p-md-3 p-xl-3 p-flex-sm-nowrap side-left">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-col-12">
                <form [formGroup]="c502SearchForm">
                  <div class="p-d-flex box-freeword">
                    <div class="input-icon-container">
                      <input type="text" pInputText class="freeword-inputtext"
                        [formControl]="c502SearchForm.controls.freeword" (keydown.enter)="getResultTaskDataList()"/>
                      <i class="pi pi-search search-icon"></i>
                    </div>
                  </div>
                  <p-accordion [multiple]="true" class="desktop">
                    <p-accordionTab header="ステータス" [(selected)]="accordion_status"
                      [disabled]="isDisabledTab('match_status')">
                      <div class="accrodion-form-list">
                        <div class="btn-check">
                          <span class="spanButtonCheckbox"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  listStatus,
                                  'match_status'
                                )
                              " class="checkBoxButton">すべて選択</a> </span>　|　
                          <span class="p-ml-2 spanButtonCheckbox"><a href="#" class="checkBoxButton" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  listStatus,
                                  'match_status'
                                )
                              ">解除</a></span>
                        </div>
                        <div *ngFor="let option of listStatus">
                          <p-checkbox [label]="option.sp_name" [value]="option.sp_code" [formControl]="
                              c502SearchForm.controls.match_status
                         " [(ngModel)]="searchMatchStatusMobile" [ngModelOptions]="{ standalone: true }"></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="実施日">
                      <p class="text-start-time">実施日(開始日)</p>
                      <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true"
                        [monthNavigator]="true" [readonlyInput]="true" placeholder="" dateFormat="yy/mm/dd"
                        dataType="string" appendTo="body" yearRange="2000:2999"
                        formControlName="match_start_implementation_date_FROM" translate></p-calendar>
                      <p class="text-connect-time center">から</p>
                      <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true"
                        [monthNavigator]="true" [readonlyInput]="true" placeholder="" dateFormat="yy/mm/dd"
                        dataType="string" appendTo="body" yearRange="2000:2999"
                        formControlName="match_start_implementation_date_TO" translate></p-calendar>

                      <p class="text-end-time">実施日(終了日)</p>
                      <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true"
                        [monthNavigator]="true" [readonlyInput]="true" placeholder="" dateFormat="yy/mm/dd"
                        dataType="string" appendTo="body" yearRange="2000:2999"
                        formControlName="match_end_implementation_date_FROM" translate></p-calendar>
                      <p class="text-connect-time center">から</p>
                      <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true"
                        [monthNavigator]="true" [readonlyInput]="true" placeholder="" dateFormat="yy/mm/dd"
                        dataType="string" appendTo="body" yearRange="2000:2999"
                        formControlName="match_end_implementation_date_TO" translate></p-calendar>
                    </p-accordionTab>
                  </p-accordion>
                  <p-accordion [multiple]="true" class="mobile" expandIcon="pi pi-fw pi-plus"
                    collapseIcon="pi pi-fw pi-minus">
                    <p-accordionTab header="ステータス" [disabled]="searchMatchStatusMobile?.length > 0">
                      <div *ngFor="let option of listStatus">
                        <p-checkbox [label]="option.sp_name" [value]="option.sp_code" [formControl]="
                          c502SearchForm.controls.match_status
                        " [(ngModel)]="searchMatchStatusMobile" [ngModelOptions]="{ standalone: true }"></p-checkbox>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="実施日">
                      <p class="text-start-time">実施日(開始日)</p>
                      <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true"
                        [monthNavigator]="true" [readonlyInput]="true" placeholder="" dateFormat="yy/mm/dd"
                        dataType="string" appendTo="body" yearRange="2000:2999"
                        formControlName="match_start_implementation_date_FROM" translate></p-calendar>
                      <p class="text-connect-time center">から</p>
                      <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true"
                        [monthNavigator]="true" [readonlyInput]="true" placeholder="" dateFormat="yy/mm/dd"
                        dataType="string" appendTo="body" yearRange="2000:2999"
                        formControlName="match_start_implementation_date_TO" translate></p-calendar>

                      <p class="text-end-time">実施日(終了日)</p>
                      <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true"
                        [monthNavigator]="true" [readonlyInput]="true" placeholder="" dateFormat="yy/mm/dd"
                        dataType="string" appendTo="body" yearRange="2000:2999"
                        formControlName="match_end_implementation_date_FROM" translate></p-calendar>
                      <p class="text-connect-time center">から</p>
                      <p-calendar [showIcon]="true" [showButtonBar]="true" [yearNavigator]="true"
                        [monthNavigator]="true" [readonlyInput]="true" placeholder="" dateFormat="yy/mm/dd"
                        dataType="string" appendTo="body" yearRange="2000:2999"
                        formControlName="match_end_implementation_date_TO" translate></p-calendar>
                    </p-accordionTab>
                  </p-accordion>
                </form>
              </div>
              <div class="p-col-12 btn-block-search">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-12">
                    <button pButton type="button" label="検索" class="p-button-danger btn-search-item"
                      (click)="getResultTaskDataList()"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-9 list-matches">
            <div class="p-fluid p-formgrid p-grid detail-item">
              <div class="p-col-12">
                <div class="card" *ngIf="class_id === '1' || class_id === '2'">
                  <p-table [value]="resultTaskDataList" [paginator]="true" [rows]="30" [scrollable]="true"
                    [tableStyle]="{'min-width': '40rem'}" scrollHeight="70vh" [(first)]="first">
                    <ng-template pTemplate="header">
                      <tr class="list-match-col">
                        <th class="list-match-title">マッチング先</th>
                        <th class="list-match-contact">一言メッセージ</th>
                        <th class="list-match-status">ステータス</th>
                        <th class="list-match-start-date p-col-2">実施日</th>
                        <th class="list-match-evaluation">実施報告</th>
                        <th class="list-match-evaluation">コーディネーター相談</th>
                        <th class="list-match-notice">メッセージ</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                      <tr class="body-row">
                        <td class="content-item" [pTooltip]="item?.needs_member_organization_name"
                          #needs_member_organization_name
                          [tooltipDisabled]="!isOverflow(needs_member_organization_name)" showDelay="500"
                          hideDelay="500" *ngIf="item?.seeds_member_id == member_id">
                          {{ item?.needs_member_organization_name }}
                        </td>
                        <td class="content-item" [pTooltip]="item?.seeds_member_organization_name"
                          #seeds_member_organization_name [tooltipDisabled]="
                            !isOverflow(seeds_member_organization_name)
                          " showDelay="500" hideDelay="500" hideDelay="500" *ngIf="item?.needs_member_id == member_id">
                          {{ item?.seeds_member_organization_name }}
                        </td>
                        <td class="content-item pointer content-item-clickable linktext-blue underline"
                          [pTooltip]="item?.oneword_message" #oneword_message
                          [tooltipDisabled]="!isOverflow(oneword_message)" showDelay="500" hideDelay="500" (click)="
                            moveNextPage(
                              item?.match_id,
                              item?.match_type,
                              item?.match_ns_id
                            )
                          ">
                          <u>{{ item?.oneword_message }}</u>
                        </td>
                        <td class="content-item match-status" [pTooltip]="item?.match_status" #match_status
                          [tooltipDisabled]="!isOverflow(match_status)" showDelay="500" hideDelay="500">
                          <div class="status-desktop" [ngClass]="setClassStatus(item?.match_status)">
                            {{ item?.match_status }}
                          </div>
                          <div class="status-mobile">
                            <div [ngClass]="
                                setClassStatus(item?.match_status, true)
                              ">
                              {{ item?.match_status }}
                            </div>
                          </div>
                        </td>
                        <td class="content-item p-col-2 list-match-start-date" pTooltip="{{
                            item?.match_start_implementation_date
                          }} 〜 {{ item?.match_end_implementation_date }}" #date [tooltipDisabled]="!isOverflow(date)"
                          showDelay="500" hideDelay="500">
                          <div>
                            {{ item?.match_start_implementation_date }}
                            <span class="seperate center" *ngIf="item?.match_end_implementation_date">〜</span>
                            {{ item?.match_end_implementation_date }}
                          </div>
                        </td>

                        <td class="content-item list-match-evaluation">
                          <span *ngIf="item?.member_seeds_report == member_id || item?.member_needs_report == member_id"
                            class="status-evalution-disable" (click)="showDialogEvaluate(item?.match_id, '0', '0')">
                            結果
                          </span>
                          <span *ngIf="showRegister(item)" (click)="moveC701(item?.match_id, item?.match_type)"
                            class="status-evalution-enable status-evalution-mobile">
                            登録する
                          </span>
                        </td>

                        <td class="content-item list-match-evaluation">
                          <ng-container *ngIf="class_id == '1'">
                            <ng-container *ngIf="item?.solution_consult_status; else emptyContent">
                              <span class="status-evalution-enable" (click)="openConsultationDialog(item)">詳細</span>
                            </ng-container>
                            <ng-template #emptyContent>
                              <span></span>
                            </ng-template>
                          </ng-container>
                          <ng-container *ngIf="class_id == '2'">
                            <ng-container *ngIf="item?.needs_consult_status; else emptyContent">
                              <span class="status-evalution-enable" (click)="openConsultationDialog(item)">詳細</span>
                            </ng-container>
                            <ng-template #emptyContent>
                              <span></span>
                            </ng-template>
                          </ng-container>
                        </td>

                        <td class="content-item list-match-notice" [pTooltip]="item?.lastest_message_comment"
                          #lastest_message_comment [tooltipDisabled]="
                            !isOverflow(lastest_message_comment)
                          " showDelay="500" hideDelay="500" [ngClass]="{
                            redStatus: item?.lastest_message_status == '0'
                          }">
                          <span href="javascript:void(0);" (click)="moveC602(item?.match_id)"
                            class="pointer underline message-text-destop">{{ item?.lastest_message_comment ? item?.lastest_message_comment : 'メッセージなし' }}</span>
                          <i (click)="moveC602(item?.match_id)"
                            class="pi pi-comment message-text-mobile"></i>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
                <div class="card" *ngIf="class_id === '9'">
                  <p-table [value]="resultTaskDataList" [paginator]="true" [rows]="30" [scrollable]="true"
                    [tableStyle]="{'min-width': '42rem'}" scrollHeight="70vh" [(first)]="first">
                    <ng-template pTemplate="header">
                      <tr class="list-match-col">
                        <th></th>
                        <th class="">
                          中学校・高校等
                        </th>
                        <th class="list-agenda-member">保育所・幼稚園等</th>
                        <th class="list-match-title">一言メッセージ</th>
                        <th class="list-match-status">ステータス</th>
                        <th class="list-match-start-date p-col-2">実施日</th>
                        <th class="list-match-evaluation">実施報告(中高生・高校等)</th>
                        <th class="list-match-notice">実施報告(保育所・幼稚園等)</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                      <tr class="body-row">
                        <td class="content-item p-px-2">
                          <button type="button" pButton class="p-p-1" label="連携事例登録"
                            (click)="moveC461(item?.match_id)"></button>
                        </td>
                        <ng-template *ngIf="item?.match_type == '2'">

                        </ng-template>
                        <td class="content-item" [pTooltip]="item?.seeds_member_organization_name"
                          #seeds_member_organization_name [tooltipDisabled]="
                            !isOverflow(seeds_member_organization_name)
                          " showDelay="500" hideDelay="500">
                          {{ item?.seeds_member_organization_name }}
                        </td>
                        <td class="content-item" [pTooltip]="item?.needs_member_organization_name"
                          #needs_member_organization_name [tooltipDisabled]="
                            !isOverflow(needs_member_organization_name)
                          " showDelay="500" hideDelay="500">
                          {{ item?.needs_member_organization_name }}
                        </td>
                        <td class="content-item pointer content-item-clickable linktext-blue underline"
                          [pTooltip]="item?.oneword_message" #oneword_message
                          [tooltipDisabled]="!isOverflow(oneword_message)" showDelay="500" hideDelay="500" (click)="
                            moveNextPage(
                              item?.match_id,
                              item?.match_type,
                              item?.match_ns_id
                            )
                          ">
                          <u>{{ item?.oneword_message }}</u>
                        </td>
                        <td class="content-item match-status">
                          <div class="status-desktop" [ngClass]="setClassStatus(item?.match_status)">
                            {{ item?.match_status }}
                          </div>
                          <div class="status-mobile">
                            <div [ngClass]="
                                setClassStatus(item?.match_status, true)
                              ">
                              {{ item?.match_status }}
                            </div>
                          </div>
                        </td>

                        <td class="content-item p-col-2 list-match-start-date" pTooltip="{{
                            item?.match_start_implementation_date
                          }} 〜 {{ item?.match_end_implementation_date }}" #date [tooltipDisabled]="!isOverflow(date)"
                          showDelay="500" hideDelay="500">
                          <div>
                            {{ item?.match_start_implementation_date }}
                            <span class="separate center" *ngIf="item?.match_end_implementation_date">〜</span>
                            {{ item?.match_end_implementation_date }}
                          </div>
                        </td>

                        <td class="content-item list-match-evaluation" [ngSwitch]="item?.agenda_solution_publish_flg">
                          <div *ngSwitchCase="'1'">
                            <span class="status-publish-flg-1 status-evalution-flg" (click)="showDialogEvaluate(item?.match_id, item?.seeds_member_id, '1')">公開</span>
                          </div>
                          <div *ngSwitchCase="'0'">
                            <span class="status-publish-flg-0 status-evalution-flg" (click)="showDialogEvaluate(item?.match_id, item?.seeds_member_id, '1')">非公開</span>
                          </div>
                          <span *ngSwitchDefault></span>
                        </td>
                        <td class="content-item list-match-evaluation" [ngSwitch]="item?.agenda_need_publish_flg">
                          <div *ngSwitchCase="'1'">
                            <span class="status-publish-flg-1 status-evalution-flg" (click)="showDialogEvaluate(item?.match_id, item?.needs_member_id, '2')">公開</span>
                          </div>
                          <div *ngSwitchCase="'0'">
                            <span class="status-publish-flg-0 status-evalution-flg" (click)="showDialogEvaluate(item?.match_id, item?.needs_member_id, '2')">非公開</span>
                          </div>
                          <span *ngSwitchDefault></span>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-evaluation-dialog *ngIf="isShowDialogEvaluate" (returnStatusDialog)="closeDialogEvaluation($event)"
  [matchId]="matchId" [reportId]="reportId" [spoofId]="spoofId" (reload)="reloadData()"></app-evaluation-dialog>
<app-c331-dialog *ngIf="isShowDialogC331" (returnStatusDialogC331)="closeDialogC331($event)" (reloadData)="reloadData()"
  [matchId]="matchId" [agendaId]="agendaId"></app-c331-dialog>
<app-c341-dialog *ngIf="isShowDialogC341" (returnStatusDialogC341)="closeDialogC341($event)" (reloadData)="reloadData()"
  [matchId]="matchId"></app-c341-dialog>
<app-consultation-dialog (returnConsultationDialog)="closeConsultationDialog($event)">
</app-consultation-dialog>